import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material"
import { TooltipCC } from "components/common";
import { IconDeleteUser, IconEditUser } from "components/common/IconCommon";
import { DIALOG_ID } from "components/Dialog/constant";
import NotFoundData from "components/NotFound";
import { PaginationButtons, TableHeaderCC } from "components/Table";
import { headCellsMCUControl } from "components/Table/Functions";
import { PATH_ROOT } from "constants/api";
import { FUNCTIONS } from "constants/roles";
import { IconViewDetail } from "pages/service-package-management/assets";
import { checkFunctionHaveCode } from "store/user/functions";
import { transHeadCells } from "utils/functions";
import { getIndexCellTable, setOpenDialogCC } from "utils/helpers";

export const MCUControlPage = ({
    sizeRow,
    dataLake,
    functions,
    t,
    setReload,
    handleOpenDialogDelete,
    currentPage,
    handleChangePage,
    isLargePC,
    navigate,
}) => {

    return (
        <Box>
            <TableContainer
                sx={{
                    overflowX: 'initial',
                    overflowY: 'auto',
                    height: isLargePC || window.innerHeight > 800 ? 'auto' : 'auto',
                }}
            >
                <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={sizeRow}>
                    <TableHeaderCC headCellTable={transHeadCells(headCellsMCUControl, t)} styleHeadCell={{ boxShadow: 'none !important', borderBottom: '1px solid rgb(209, 209, 209) !important' }} />
                    <TableBody>
                        {dataLake?.data && dataLake?.data.map((data, index) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={data.id} sx={{ cursor: 'auto' }}>
                                    <TableCell align="center">{getIndexCellTable(currentPage, 10, index)}</TableCell>
                                    <TableCell sx={{ width: '563px' }}>{data.room_number}</TableCell>
                                    <TableCell sx={{ width: '916px' }}>{data.room_name}</TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            {
                                                checkFunctionHaveCode(functions, FUNCTIONS.MCU_CONTROL_ROOM_VIEW)
                                                &&
                                                <TooltipCC title={t('mcu.tooltip.viewDetail')}>
                                                    <IconButton onClick={() => { navigate(`${PATH_ROOT}/mcu-control/control-room/${data.room_number}`) }} size={sizeRow}>
                                                        <IconViewDetail />
                                                    </IconButton>
                                                </TooltipCC>
                                            }

                                            {
                                                checkFunctionHaveCode(functions, FUNCTIONS.MCU_CONTROL_ROOM_EDIT)
                                                &&
                                                <TooltipCC title={t('mcu.tooltip.edit')}>
                                                    <IconButton
                                                        onClick={() => {
                                                            setOpenDialogCC({
                                                                id: DIALOG_ID.CREATE_MCU_ROOM,
                                                                props: {
                                                                    title: t('mcu.dialog.title.editRoom'),
                                                                    titleButtonAction: t('mcu.dialog.action.editRoom'),
                                                                    titleButtonCancel: t('mcu.dialog.action.cancel'),
                                                                    data: {
                                                                        name: data.room_name,
                                                                        code: data.room_number,
                                                                        id: data.id
                                                                    },
                                                                    agreeAction: () => {
                                                                        setReload((prev) => !prev);
                                                                    },
                                                                },
                                                            });
                                                        }}
                                                        size={sizeRow}
                                                    >
                                                        <IconEditUser />
                                                    </IconButton>
                                                </TooltipCC>
                                            }
                                            {
                                                checkFunctionHaveCode(functions, FUNCTIONS.MCU_CONTROL_ROOM_EDIT)
                                                &&
                                                <TooltipCC title={t('mcu.tooltip.delete')}>
                                                    <IconButton onClick={() => { handleOpenDialogDelete(data.room_name, data.id) }} size={sizeRow}>
                                                        <IconDeleteUser />
                                                    </IconButton>
                                                </TooltipCC>
                                            }
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {dataLake.totalElements ? <PaginationButtons page={currentPage} handleChangePage={handleChangePage} limit={10} total={dataLake.totalElements} /> : <></>}
            {dataLake.totalElements === 0 && <NotFoundData />}
        </Box>
    )
}
